export enum NotificationAudienceEnum {
  SPECIFIC = 'SPECIFIC',
  OTHER = 'OTHER'
}
